import { Component, inject, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DEFAULT_PRODUCT_WEIGHT } from '@banyan/commons/consts/global.const';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { AccountService } from '@banyan/modules/account/services/account.service';
import { FragranceCatalogService } from '@banyan/modules/catalog/services/fragrance-catalog.service';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { CatalogProductCategoryPanelComponent } from '@banyan/modules/standalone/catalog-product-category-panel/catalog-product-category-panel.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import {
  ImageFullscreenModalComponent,
} from '@banyan/modules/standalone/image-fullscreen-modal/image-fullscreen-modal.component';
import { PlusMinusButtonComponent } from '@banyan/modules/standalone/plus-minus-button/plus-minus-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fragrance-catalog-product',
  standalone: true,
  imports: [
    TranslateModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    DefaultCurrencyPipe,
    GradientComponent,
    PlusMinusButtonComponent,
    ButtonComponent,
    ImageFullscreenModalComponent,
    CatalogProductCategoryPanelComponent
  ],
  templateUrl: './fragrance-catalog-product.component.html',
  styleUrls: ['./fragrance-catalog-product.component.scss'],
})
export class FragranceCatalogProductComponent implements OnInit {
  route = inject(ActivatedRoute);
  accountService = inject(AccountService);
  fragranceCatalogService = inject(FragranceCatalogService);
  minQuantityToOrder: number = DEFAULT_PRODUCT_WEIGHT;
  quantity: number = DEFAULT_PRODUCT_WEIGHT;

  isFullScreenModalOpen = false;

  ngOnInit() {
    const id = Number.parseInt(this.route.snapshot.params['id']);
    if (id) {
      this.fragranceCatalogService.getProduct(id);
    }
    this.quantity = this.fragranceCatalogService.product()?.minimumQuantity ?? DEFAULT_PRODUCT_WEIGHT;
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/catalog-default-product.png';
  }

  updateQuantity(quantity: number): void {
    this.quantity = quantity;
  }

  openModal() {
    this.isFullScreenModalOpen = true;
  }

  closeModal = () => {
    this.isFullScreenModalOpen = false;
  };

}